var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502.61 398.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#49454f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ROTATE1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.81,166.54A22.83,22.83,0,0,1,40,168.79h0L63,195.15A220.35,220.35,0,0,1,282,0a22.86,22.86,0,1,1,1,45.71h-1A174.51,174.51,0,0,0,158.28,97C126.68,128.6,110.4,169.2,108,210.57l40-34.74a22.86,22.86,0,0,1,30,34.49l-75.2,65.4c-.31.28-.73.34-1.06.61a22.26,22.26,0,0,1-4.43,2.51,21.89,21.89,0,0,1-3.72,1.53c-.52.14-.91.48-1.45.58a22.47,22.47,0,0,1-3.07,0,21.27,21.27,0,0,1-2.86.35,11.75,11.75,0,0,1-1.47-.39,21.66,21.66,0,0,1-4.35-1.17,1.33,1.33,0,0,1-.37-.09,21.67,21.67,0,0,1-2.27-.61c-.45-.22-.79-.7-1.23-1a22,22,0,0,1-3.69-2.83,23.17,23.17,0,0,1-2.29-1.76L5.62,198.81A22.83,22.83,0,0,1,7.83,166.6l0,0Z",
    transform: "translate(0 0.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.28,146.33a22.87,22.87,0,0,1,16.16-6.71H479.76a22.89,22.89,0,0,1,22.85,22.85v213.3a22.9,22.9,0,0,1-22.85,22.86H266.46a22.88,22.88,0,0,1-22.85-22.86V162.51A22.77,22.77,0,0,1,250.28,146.33Zm39,206.62H456.91V185.33H289.28Z",
    transform: "translate(0 0.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRLeft);
export default __webpack_public_path__ + "static/media/r_left.de1411200e8aaf5632e051628c267ae7.svg";
export { ForwardRef as ReactComponent };